/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;align-items:center;padding:15px;border-top:1px solid var(--be-divider-default);background-color:var(--be-background-alternative);color:var(--be-secondary-text)}.social[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}"];
export { styles as styles };
